module.exports = __webpack_public_path__ + "media/images/lb/108-b4bc8f86351052be6fdc3defc10c8dec.svg";